import { CompetitionData } from "@/app/components/ActiveCompetitions/types";

const COLORS = {
  "navigation-orange": {
    title: "text-nav-orange",
    bgBadge: "bg-nav-orange/20",
    textBadge: "text-nav-badge-orange",
  },
  "navigation-blue": {
    title: "text-nav-blue",
    bgBadge: "bg-nav-blue/20",
    textBadge: "text-nav-badge-blue",
  },
  "navigation-purple": {
    title: "text-nav-purple",
    bgBadge: "bg-nav-purple/20",
    textBadge: "text-nav-badge-purple",
  },
  "navigation-turquoise": {
    title: "text-nav-turquoise",
    bgBadge: "bg-nav-turquoise/20",
    textBadge: "text-nav-badge-turquoise",
  },
  "navigation-red": {
    title: "text-nav-red",
    bgBadge: "bg-nav-red/20",
    textBadge: "text-nav-badge-red",
  },
  "navigation-white": {
    title: "text-nav-white",
    bgBadge: "bg-nav-white/20",
    textBadge: "text-nav-badge-white",
  },
  "navigation-azure": {
    title: "text-nav-azure",
    bgBadge: "bg-nav-azure/20",
    textBadge: "text-nav-badge-azure",
  },
  "navigation-green": {
    title: "text-nav-green",
    bgBadge: "bg-nav-green/20",
    textBadge: "text-nav-badge-green",
  },
  "navigation-dark-fuchsia": {
    title: "text-nav-dark-fuchsia",
    bgBadge: "bg-nav-dark-fuchsia/20",
    textBadge: "text-nav-badge-dark-fuchsia",
  },
  "navigation-dark-blue": {
    title: "text-nav-dark-blue",
    bgBadge: "bg-nav-dark-blue/20",
    textBadge: "text-nav-badge-dark-blue",
  },
} as const;

interface CompetitionListItemProps {
  competition: CompetitionData;
  isLast?: boolean;
  dividerClassName?: string;
}

export default function CompetitionListItem({ competition, isLast, dividerClassName = "" }: CompetitionListItemProps) {
  const colors = COLORS[competition.NavigationColour as keyof typeof COLORS];

  return (
    <div>
      <div className="flex items-center justify-between py-2.5 overflow-hidden">
        <div className="flex gap-4 items-center min-w-0">
          <div className="rounded-[4px] shrink-0 size-10 lg:size-[50px] bg-gray-11 overflow-hidden">
            {competition.ImageUrl && (
              <img src={competition.ImageUrl} alt={competition.Title} className="w-full h-full object-cover" />
            )}
          </div>

          <div className="flex flex-col gap-2 items-start min-w-0">
            <div className="flex flex-col gap-1 lg:gap-2 items-start min-w-0 w-full">
              <p
                className={`m-0 p-0 tracking-[0] text-[14px] lg:text-base font-semibold font-jost leading-5 lg:leading-5.5 truncate w-full ${colors?.title ?? ""}`}>
                {competition.Title}
              </p>

              <div
                className={`flex items-center justify-center px-1 py-0.5 rounded-[4px] shrink-0 ${colors?.bgBadge ?? ""}`}>
                <p
                  className={`m-0 p-0 tracking-[0] text-[10px] lg:text-[13px] font-medium font-jost leading-3 lg:leading-4.5 whitespace-nowrap ${colors?.textBadge ?? ""}`}>
                  ENDS {competition.EndDate.toUpperCase()}
                </p>
              </div>
            </div>

            <div className="flex gap-1 items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#308835"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="shrink-0"
                aria-hidden="true">
                <circle cx="12" cy="12" r="10" />
                <path d="m9 12 2 2 4-4" />
              </svg>
              <p className="m-0 p-0 tracking-[0] text-[11px] lg:text-[13px] font-medium font-jost leading-3.5 lg:leading-[18px] text-green-11 whitespace-nowrap">
                {`You're entered with ${competition.TicketsInComp ?? 0} tickets`}
              </p>
            </div>
          </div>
        </div>

        <a
          href={competition.PageUrl}
          className="bg-[#eeeeef] flex items-center justify-center h-7 lg:h-8 px-2.5 py-1 rounded-lg shrink-0 ml-3">
          <span className="text-blue text-xs lg:text-sm font-medium font-jost leading-normal lg:leading-5">
            DETAILS
          </span>
        </a>
      </div>

      {!isLast && (
        <hr className={`m-0 border-0 border-t border-black/[0.08] ml-[56px] lg:ml-[66px] ${dividerClassName}`} />
      )}
    </div>
  );
}
